import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

import { defaultSessionEnd, defaultSessionStart } from "../../constants";
import { getHours, getMinutes, ofTimeOnlyWithZ } from "../../utils/time-utils";
import { TimePickerDropdown as TimePicker } from "../Utilities/TimePickerDropdown";

// PropTypes
type TimePickerModalProps = {
  show: boolean;
  toggle?: boolean;
  centered?: boolean;
  currentItem: {
    start: string;
    end: string;
    datetime?: Date;
  };
  title?: string;
  onToggle?: () => void;
  onHide: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

// Time Picker
export default function TimePickerModal({
  show,
  onHide,
  onSubmit,
  currentItem,
  title,
  toggle,
  onToggle,
}: TimePickerModalProps) {
  const { t } = useTranslation();
  const start = ofTimeOnlyWithZ(currentItem.start);
  const end = ofTimeOnlyWithZ(currentItem.end);
  return (
    <Dialog open={show} onClose={onHide} fullWidth maxWidth="sm">
      <DialogTitle
        style={{
          color: "#525252",
          marginBottom: -25,
        }}
      >
        {title ? title : "Time Picker"}
      </DialogTitle>
      <hr />
      <form onSubmit={onSubmit} onReset={onHide}>
        <DialogContent>
          <TimePicker
            from={{
              hours: getHours(toggle ? defaultSessionStart : start),
              minutes: toggle ? 0 : getMinutes(start),
            }}
            to={{
              hours: getHours(toggle ? defaultSessionEnd : end),
              minutes: toggle ? 0 : getMinutes(end),
            }}
            disabled={toggle}
          />
          <hr />
          <Grid container>
            <Grid item xs={6} sm={4}>
              {onToggle && (
                <label htmlFor="toggle">
                  {t("Not available")}
                  <span
                    id="toggle"
                    className={toggle ? "toggle-container toggled" : "toggle-container"}
                    onClick={onToggle}
                  >
                    <span className="toggle-button" />
                  </span>
                </label>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            type="reset"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#333333",
              textTransform: "capitalize",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "var(--text-primary)",
              color: "#ffffff",
              textTransform: "capitalize",
            }}
          >
            {t("Done")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
